<template>
  <div class="with-side-panel">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">
            {{ $t('dashboard.dashboard_for') + piniaUserStore().currentUser?.user?.userAccessRightsTranslation }}
          </h6>

          <Menu/>

          <div class="element-box mt-4">
            <div class="row mt-2">
              <CoachingButton
                  :enabled="companySettings?.privateCoachingEnabled"
                  route-name="privateCoachingNewAndActiveList"
                  coaching-type="private"
                  label="Einzelcoaching"/>
              <CoachingButton
                  :enabled="companySettings?.groupCoachingEnabled"
                  route-name="groupCoachingNewAndActiveList"
                  coaching-type="group"
                  label="Gruppenmaßnahmen"/>
              <CoachingButton
                  :enabled="companySettings?.socioTherapyCoachingEnabled"
                  route-name="socioTherapyCoachingNewAndActiveList"
                  coaching-type="socioTherapy"
                  label="Soziotherapie"/>
              <CoachingButton
                  :enabled="companySettings?.assistedLivingCoachingEnabled"
                  route-name="assistedLivingCoachingNewAndActiveList"
                  coaching-type="assistedLiving"
                  label="Betreutes Wohnen"/>
              <CoachingButton
                  :enabled="companySettings?.caseManagementCoachingEnabled"
                  route-name="caseManagementCoachingNewAndActiveList"
                  coaching-type="caseManagement"
                  label="DRV Fallmanagement"/>
              <CoachingButton
                  :enabled="companySettings?.privateLearningCoachingEnabled"
                  route-name="privateLearningCoachingNewAndActiveList"
                  coaching-type="privateLearning"
                  label="Private Weiterbildung"/>
            </div>

            <h6 class="mt-5">{{ $t('general.active_customers') }}</h6>
            <div class="row mt-3">
              <div class="col-lg-3 col-md-6 col-sm-12">
                <CardInfo
                    :label="'Einzelcoaching'"
                    :value="infoData?.countActiveCoaching?.counts?.privateCoaching"/>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12">
                <CardInfo
                    :label="'Gruppenmaßnahmen'"
                    :value="infoData?.countActiveCoaching?.counts?.groupCoaching"/>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12">
                <CardInfo
                    :label="'Soziotherapie'"
                    :value="infoData?.countActiveCoaching?.counts?.socioTherapyCoaching"/>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12">
                <CardInfo
                    :label="'Private Weiterbildung'"
                    :value="infoData?.countActiveCoaching?.counts?.privateLearningCoaching"/>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12">
                <CardInfo
                    :label="'DRV Fallmanagement'"
                    :value="infoData?.countActiveCoaching?.counts?.caseManagementCoaching"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FormSidebar>
        <template #top>
          <h6 class="element-header">
            Sidebar
          </h6>
        </template>

        <div class="element-box">
          <h6>{{ $t('general.active_customers') }}</h6>
          <VueApexCharts width="100%" type="donut" :options="chartOptions" :series="seriesActiveCoach"/>
        </div>
      </FormSidebar>
    </div>
  </div>
</template>

<script setup>
import CardInfo from '@/components/card/CardInfo.vue';
import CoachingButton from '@/components/button/CoachingButton.vue';
import Menu from '@/views/App/Dashboard/Accountant/Menu.vue';
import FormSidebar from '@/components/FormSidebar.vue';
import {ErrorToast} from '@/components/VueToast';
import {computed, onMounted, ref} from 'vue';
import VueApexCharts from 'vue3-apexcharts';
import {optionsChartDonut} from '@/shared/utils/apex';
import dashboardAccountantService from '@/api/Dashboard/Accountant';
import {piniaUserStore} from '@/store/piniaUserStore';
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";

const piniaCompanySettingsState = piniaCompanySettingsStore()
const companySettings = computed(() => piniaCompanySettingsState.companySettings)

const chartOptions = ref(optionsChartDonut);
const seriesActiveCoach = ref([]);
const infoData = ref({});

async function getInfoData() {
  try {
    const {data} = await dashboardAccountantService.getInfoData();
    infoData.value = data.data;

    seriesActiveCoach.value = Object.values(data.data.countActiveCoaching?.counts);
    chartOptions.value = {
      ...chartOptions.value,
      labels: [
        `Einzelcoaching ${data.data.countActiveCoaching.counts?.privateCoaching}`,
        `Soziotherapie ${data.data.countActiveCoaching.counts?.socioTherapyCoaching}`,
        `Betreutes Wohnen ${data.data.countActiveCoaching.counts?.assistedLivingCoaching}`,
        `Gruppenmaßnahmen ${data.data.countActiveCoaching.counts?.groupCoaching}`,
        `DRV Fallmanagement ${data.data.countActiveCoaching.counts?.caseManagementCoaching}`,
        `Private Weiterbildung ${data.data.countActiveCoaching.counts?.privateLearningCoaching}`
      ],
      plotOptions: {
        pie: {
          donut: {
            ...chartOptions.value.plotOptions.pie.donut,
            labels: {
              ...chartOptions.value.plotOptions.pie.donut.labels,
              total: {
                ...chartOptions.value.plotOptions.pie.donut.labels.total,
                formatter: () => data.data.countActiveCoaching?.total.toString()
              }
            }
          }
        }
      }
    };
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(() => {
  getInfoData();
})

</script>

<style scoped>

::v-deep(.apexcharts-legend) {
  display: block !important;
}

</style>